module.exports = __webpack_public_path__ + "img/login-logo-n.7e2effcb.png";